import deepEqual from "fast-deep-equal";
import type { AnyRecord } from "../types";

export const getChangedFields = <T extends object>(oldObj: T, newObj: T): Partial<T> =>
  Object.entries(newObj).reduce<Partial<T>>((result, [key, newValue]) => {
    if (!deepEqual(oldObj[key as keyof T], newValue)) {
      result[key as keyof T] = newValue as T[keyof T];
    }

    return result;
  }, {});

export const isObject = <T>(value: T): boolean => Object.prototype.toString.call(value) === "[object Object]";

export const isEmptyObject = (obj: object): boolean => Object.keys(obj).length === 0;

export const parseJson = <T>(jsonString: string): NonNullable<T> | undefined => {
  try {
    const result = JSON.parse(jsonString);
    if (result === null) {
      return undefined;
    }

    return result as NonNullable<T>;
  } catch {
    return undefined;
  }
};

export const parseJsonObject = <T extends AnyRecord>(jsonString: string): T | undefined => {
  const result = parseJson<T>(jsonString);
  if (result === undefined || !isObject(result)) {
    return undefined;
  }

  return result;
};
